import React from "react";
import CommonInfoTab from "../Common/CommonInfoTab";
import Card from "@mui/joy/Card";

// icons
import SupportIcon from '@mui/icons-material/Support';


class ApplicantCard extends React.Component {
    render() {
        return(
            <Card
                variant={'plain'}
                size={'sm'}
            >
                <CommonInfoTab
                    flat={true}
                    groups={
                        [
                            {
                                title: `${this.props.applicant.last_name} ${this.props.applicant.first_name} ${this.props.applicant.patronymic}`,
                                icon: <SupportIcon/>,
                                linkPattern: '/hr/applicant/detail/:linkParam',
                                linkParam: this.props.applicant.id,
                                flat: true,
                                fields: [
                                    {
                                        title: 'Тип',
                                        value:  this.props.applicant.xtype_human,
                                        flat: true,
                                        xs: 6,
                                        sm: 6,
                                        md: 6,
                                        lg: 6,
                                    },
                                    {
                                        title: 'Статус',
                                        value:  this.props.applicant.status?.title,
                                        flat: true,
                                        xs: 6,
                                        sm: 6,
                                        md: 6,
                                        lg: 6,
                                    },
                                    {
                                        title: 'Инструктор',
                                        value:  `${this.props.applicant.instructor?.last_name} ${this.props.applicant.instructor?.first_name}`,
                                        flat: true,
                                        xs: 6,
                                        sm: 6,
                                        md: 6,
                                        lg: 6,
                                    },
                                ]
                            },
                        ]
                    }
                />
            </Card>
        )
    }
}

export default ApplicantCard
